import { useCallback } from 'react'

import { DEFAULT_BIG_PAGE_SIZE } from '@/constants'
import { useProfileStore } from '@/stores/user/profileStore'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import type { ConstructionSiteInterface } from '@/types'
import api from '@/utils/api/api'
import { getApiErrorData } from '@/utils/api/errors/errorGuards'

type UseConstructionSitesParametersType = {
  setConstructionSitesLoading?: (constructionSitesLoading: boolean) => void
  setConstructionSites: (
    constructionSites: ConstructionSiteInterface['constructionSiteModel'][]
  ) => void
}

export default function useConstructionSites(
  props: UseConstructionSitesParametersType
) {
  const { setConstructionSitesLoading, setConstructionSites } = props
  const { organisation, selectedOrganisation, currentClient } =
    useUserInfoStore((state) => state)
  const { setUpdateConstructionSites } = useProfileStore((state) => state)

  const getConstructionSites = useCallback(async () => {
    const orgId = selectedOrganisation?.id || organisation?.id

    if (!orgId) {
      return { status: 'error', message: 'Организация не определена' }
    }

    let clientId: string | null = null
    if (currentClient?.id) {
      clientId = currentClient.id
    }

    try {
      if (setConstructionSitesLoading) setConstructionSitesLoading(true)

      const response = await api.get(
        // organisationId передается сюда, в путь (path)
        `/organisations/${orgId}/construction-sites`,
        {
          params: {
            // organisationId: orgId, <-- УБРАНО (он уже в URL, в params передаются только query-параметры)
            client: clientId,
            page: 0,
            pageSize: DEFAULT_BIG_PAGE_SIZE,
          },
        }
      )

      // Согласно OpenAPI ответ в поле constructionSites.content
      const data = response.data.constructionSites || response.data
      const content = data.content || []

      setConstructionSites(content)
      setUpdateConstructionSites(false)

      if (setConstructionSitesLoading) setConstructionSitesLoading(false)
      return { status: 'success', message: 'Объекты успешно загружены' }
    } catch (err: unknown) {
      if (setConstructionSitesLoading) setConstructionSitesLoading(false)
      setUpdateConstructionSites(false)
      return {
        status: 'error',
        message: getApiErrorData(err)?.message || 'Ошибка загрузки объектов',
      }
    }
  }, [
    organisation?.id,
    selectedOrganisation?.id,
    currentClient?.id,
    setConstructionSites,
    setConstructionSitesLoading,
    setUpdateConstructionSites,
  ])

  return getConstructionSites
}
